export default "__VITE_ASSET__yNsSJ0AE__"